import React, { useCallback, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';

// Hooks
import { useDeepEqualSelector } from 'Shared/utils/hooks';

// Selectors
import { getMeetingItemByUuid } from 'Shared/selectors/common';

// Actions
import { updateItem } from 'Shared/actions/todos';

import ActionsMenu from '../ActionsMenu/ActionsMenu';
import BaseButton from 'Shared/components/MeetingItemsContainer/partials/BaseButton';

import ViewDetailsButton from 'Shared/components/MeetingItemsContainer/partials/ViewDetailsButton';

// Styles
import './ActionsAreaForActionItem.scss';

type Props = {
  uuid: string;
  parentUuid: string;
  onAttachmentAdd: (event: ChangeEvent<HTMLInputElement>) => void;
  onArrowUpClick: Function;
};

function ActionsAreaForActionItem({ uuid, onAttachmentAdd, parentUuid, onArrowUpClick }: Props) {
  const dispatch = useDispatch();

  const { isHighPriority, itemType } = useDeepEqualSelector(state => getMeetingItemByUuid(uuid)(state));

  const handleTogglePriority = useCallback(() => {
    dispatch(updateItem(uuid, { isHighPriority: !isHighPriority, itemType }));
  }, [dispatch, uuid, isHighPriority, itemType]);

  const baseClassName = 'ActionsAreaForActionItem';
  return (
    <div className={baseClassName}>
      {!parentUuid && (
        <BaseButton
          icon="thumbtack"
          iconPrefix={isHighPriority ? 'fas' : 'fal'}
          color={isHighPriority ? 'danger' : 'gray'}
          variant={isHighPriority ? 'primary' : 'tertiary'}
          tooltip={isHighPriority ? 'High priority' : 'Make high priority'}
          onClick={handleTogglePriority}
          qaTest="ActionsAreaForActionItem-high-priority-btn"
        />
      )}
      <ActionsMenu uuid={uuid} onAttachmentAdd={onAttachmentAdd} onArrowUpClick={onArrowUpClick} />
      <ViewDetailsButton uuid={uuid} />
    </div>
  );
}

export default React.memo(ActionsAreaForActionItem);
